import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";

import { track } from "../store/kikudooTracking";

export const Label = styled.small`
  display: block;
  font-size: 0.7rem;
  text-align: right;
  color: ${props => props.theme.gray600};
`;

const formats = {
  banner: css`
    margin-bottom: 1.5rem;

    img {
      display: block;
      width: 100%;
    }
  `,
  skyscraper: css`
    height: 100%;

    a {
      display: block;
      max-width: 360px;
      margin: 0 auto;
    }

    img {
      display: block;
      width: 100%;
    }

    @media (${props => props.theme.tabletScreen}) {
      a {
        position: sticky;
        top: 6rem;
      }
    }
  `,
  takeover: css`
    @media (${props => props.theme.tabletScreen}) {
      position: fixed;
      inset: 0;
      z-index: 0;

      a,
      picture,
      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      img {
        object-fit: cover;
        object-position: center top;
      }

      ${Label} {
        position: absolute;
        top: 0.25rem;
        right: 0.5rem;
      }
    }
  `,
};

const Slot = styled.aside`
  position: relative;
  img {
    max-width: 100%;
    height: auto;
  }
  ${props => formats[props.type]}
`;

export const PlacementPicture = ({ placement }) => (
  <picture>
    {placement.mobileImage && <source media="(max-width: 767px)" srcSet={placement.mobileImage} />}
    <img src={placement.image || placement.mobileImage} alt={placement.content || ""} />
  </picture>
);

PlacementPicture.propTypes = {
  placement: PropTypes.object.isRequired,
};

/** Renders a banner, skyscraper or takeover and counts its view through the tracking pixel. */
const PlacementSlot = ({ placement, type, intl }) => {
  useEffect(() => {
    track("a", placement.id);
  }, [placement.id]);

  return (
    <Slot type={type}>
      <a
        href={placement.url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        aria-label={
          placement.content ||
          placement.actionName ||
          intl.formatMessage({ id: "components.Placement.label" })
        }
      >
        <PlacementPicture placement={placement} />
      </a>
      <Label>
        <FormattedMessage id="components.Placement.label" />
      </Label>
    </Slot>
  );
};

PlacementSlot.propTypes = {
  placement: PropTypes.object.isRequired,
  type: PropTypes.oneOf(["banner", "skyscraper", "takeover"]).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(PlacementSlot);
